<script context="module">
  import { API_DIR, SESSION_LS } from "./store";
  import { toasts, ToastContainer, FlatToast } from "svelte-toasts";

  toasts.setDefaults({
    theme: "light",
    placement: "bottom-right",
    type: "success",
    duration: 5000,
    showProgress: true,
    onClick: () => {},
    onRemove: () => {}
  });

  /*const toast = toasts.add({
    title: "Alert",
    description: "Your changes will be lost!",
    duration: 0,
  });*/

  /*setTimeout(() => {
    toast.remove();
    // or
    // toasts.getById(toast.uid).remove();
  }, 3000);*/

  export async function checkSessionExists(sessionID) {
    try {
      const response = await fetch(
        `${document
          .getElementById("api_dir")
          .getAttribute("value")}/api/v1/check-session?sessionID=${sessionID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Session-Id": localStorage.getItem("session_id")
          }
        }
      );

      if (response.ok) {
        /*console.log("response", response);
        const data = await response.json();
        return data.exists;*/
        return true
      } else {
        throw new Error("Error en la solicitud");
      }
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  }

  export async function cancelUpdate(jobId) {
    try {
      showLoadingModal.set(true);

      const response = await fetch(
        `${document
          .getElementById("api_dir")
          .getAttribute("value")}/api/v1/set-update-status`,
        {
          method: "POST",
          body: JSON.stringify({ update_id: jobId, new_status: "canceled" }),
          headers: {
            "Content-Type": "application/json",
            "Session-Id": localStorage.getItem("session_id")
          }
        }
      );

      showLoadingModal.set(false);

      if (response.status === 401) {
        location.reload();
      }

      if (!response.ok) {
        toasts.error("Could not cancel update");
      }

      if (response.ok) {
        toasts.success("Updtate canceled");
        setUpTable();
      }
    } catch (error) {
      console.log(error);
    }
  }

  export function downloadCSV(data, filename) {
    const csvData = convertToCSV(data);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    if (navigator.msSaveBlob) {
      // Para IE y Edge
      navigator.msSaveBlob(blob, filename);
    } else {
      // Para otros navegadores
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // URL.createObjectURL() crea un enlace temporal al archivo
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        // Simulamos un clic en el enlace para iniciar la descarga
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  function convertToCSV(data) {
    const rows = [];
    const headers = Object.keys(data[0]);

    // Agregamos las filas al arreglo
    rows.push(headers.join(","));

    for (let i = 0; i < data.length; i++) {
      const values = headers.map((header) => {
        const value =
          data[i][header] !== undefined
            ? data[i][header].toString().replace(/"/g, '\\"')
            : "";
        const escaped = value.replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      rows.push(values.join(","));
    }

    // Unimos las filas en un solo string
    return rows.join("\n");
  }

  export function movePropertyToFront(obj, propertyName) {
    const newObj = {};

    // Verificar si la propiedad existe en el objeto original
    if (obj.hasOwnProperty(propertyName)) {
      newObj[propertyName] = obj[propertyName];
    }

    // Copiar las demás propiedades al nuevo objeto
    for (let key in obj) {
      if (key !== propertyName && obj.hasOwnProperty(key)) {
        newObj[key] = obj[key];
      }
    }

    return newObj;
  }

  export function convertUnixToDate(unixTimestamp) {
    const date = new Date(unixTimestamp);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }

  export async function convertCsvToJson(csvContent) {
    const results = [];
    const rows = csvContent.split("\n");
    const headers = rows[0].split(",");

    for (let i = 1; i < rows.length; i++) {
      const row = rows[i].split(",");
      const rowData = {};

      for (let j = 0; j < headers.length; j++) {
        const header = headers[j];
        let cellValue = row[j];

        // Verificar si cellValue existe antes de eliminar comillas dobles
        if (cellValue && cellValue.startsWith('"') && cellValue.endsWith('"')) {
          cellValue = cellValue.substring(1, cellValue.length - 1);
        }

        rowData[header] = cellValue;
      }

      results.push(rowData);
    }

    return results;
  }

  export function getCookieValue(name) {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + "=")) {
        return cookie.substring(name.length + 1);
      }
    }
    return "";
  }

  // Función para calcular el CRC-16/XMODEM
  export function crc16(str, crc = 0, xorout = 0) {
    for (let i = 0, t; i < str.length; i++, crc &= 0xffff) {
      t = (crc >> 8) ^ str.charCodeAt(i);
      t ^= t >> 4;
      crc = (crc << 8) ^ (t << 12) ^ (t << 5) ^ t;
    }
    return crc ^ xorout;
  }

  export function crc16Bytes(byteArray, crc = 0, xorout = 0) {
    for (let i = 0, t; i < byteArray.length; i++, crc &= 0xffff) {
      t = (crc >> 8) ^ byteArray[i];
      t ^= t >> 4;
      crc = (crc << 8) ^ (t << 12) ^ (t << 5) ^ t;
    }
    return crc ^ xorout;
  }

  /*export function crc16FromFile(file) {
    const readerBlob = new FileReader();

    readerBlob.readAsArrayBuffer(file);
    readerBlob.onload = function () {
      const arrayBuffer = readerBlob.result;
      const byteArray = new Uint8Array(arrayBuffer);

      console.log("HEX:", byteArrayToHexString(byteArray));

      // Convertir la cadena hex en un array de bytes
      const byteValues = byteArrayToHexString(byteArray)
        .split(" ")
        .map((hex) => parseInt(hex, 16));

      let lastTwoBytesHex = getLastTwoBytesHex(byteValues);

      console.log("Last hex", lastTwoBytesHex);

      const byteArrayWithoutLastTwo = byteArray.slice(0, -2);

      const crc16 = calculateCRC16(byteArrayWithoutLastTwo)
        .toString(16)
        .toUpperCase()
        .padStart(4, "0");
      console.log("XModem from blob:", crc16);

      console.log("EQUAL:", lastTwoBytesHex == crc16);
    };
    readerBlob.onerror = function (error) {
      console.log("Error:", error);
    };
  }*/

  export async function fileHasChecksum(file) {
    try {
      const byteArray = await readFileAsByteArray(file);

      //console.log("HEX:", byteArrayToHexString(byteArray));

      const byteValues = byteArrayToHexArray(byteArray);
      const lastTwoBytesHex = getLastTwoBytesHex(byteValues);

      //console.log("Last hex:", lastTwoBytesHex);

      const byteArrayWithoutLastTwo = byteArray.slice(0, -2);

      const calculatedCrc16 = calculateCRC16(byteArrayWithoutLastTwo)
        .toString(16)
        .toUpperCase()
        .padStart(4, "0");

      console.log("XModem from blob:", calculatedCrc16);

      const crcMatches = lastTwoBytesHex === calculatedCrc16;
      //console.log(crcMatches);

      return crcMatches;
    } catch (error) {
      console.log("Error:", error);
      return false;
    }
  }

  export async function readFileAsByteArray(file) {
    return new Promise((resolve, reject) => {
      const readerBlob = new FileReader();

      readerBlob.onload = () => {
        const arrayBuffer = readerBlob.result;
        const byteArray = new Uint8Array(arrayBuffer);
        resolve(byteArray);
      };

      readerBlob.onerror = (error) => {
        reject(error);
      };

      readerBlob.readAsArrayBuffer(file);
    });
  }

  function byteArrayToHexArray(byteArray) {
    return byteArrayToHexString(byteArray)
      .split(" ")
      .map((hex) => parseInt(hex, 16));
  }

  function getLastTwoBytesHex(byteArray) {
    return byteArray
      .slice(-2)
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join(" ")
      .toLocaleUpperCase()
      .replace(" ", "");
  }

  function calculateCRC16(byteArray) {
    const polynomial = 0x1021;
    let crc = 0;

    for (let byte of byteArray) {
      crc ^= byte << 8;

      for (let i = 0; i < 8; i++) {
        if (crc & 0x8000) {
          crc = (crc << 1) ^ polynomial;
        } else {
          crc <<= 1;
        }
      }
    }

    return crc & 0xffff;
  }

  export function crc16Base64(base64String, crc = 0, xorout = 0) {
    const byteArray = base64ToByteArray(base64String);
    /*console.log(base64String);
    console.log(byteArray);
    console.log(byteArrayToHexString(byteArray));*/

    for (let i = 0, t; i < byteArray.length; i++, crc &= 0xffff) {
      t = (crc >> 8) ^ byteArray[i];
      t ^= t >> 4;
      crc = (crc << 8) ^ (t << 12) ^ (t << 5) ^ t;
    }

    return crc ^ xorout;
  }

  function base64ToByteArray(base64) {
    const binaryString = atob(base64);
    const byteArray = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }

    return byteArray;
  }

  function byteArrayToHexString(byteArray) {
    return Array.from(byteArray, (byte) => {
      return ("0" + (byte & 0xff).toString(16)).slice(-2);
    }).join(" ");
  }

  export async function calculateCRCFromFile(file) {
    try {
      const byteArray = await convertToByteArray(file);
      const crc = crc16Bytes(byteArray);
      console.log(crc);

      return crc.toString(16).toUpperCase();
    } catch (error) {
      console.error("Error:", error.message);
      return null;
    }
  }

  async function convertToByteArray(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const fileByteArray = [];

      reader.onload = (evt) => {
        const arrayBuffer = evt.target.result;
        const byteArray = new Uint8Array(arrayBuffer);

        for (let i = 0; i < byteArray.length; i++) {
          fileByteArray.push(byteArray[i]);
        }

        console.log("File Bytes:", fileByteArray); // Imprimir el array de bytes en la consola

        resolve(fileByteArray);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  }


  export function getRandString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}
  /*const reader = new FileReader();
reader.readAsDataURL(file);
reader.onload = function () {
  const crcResult64 = reader.result.split(",")[1];
  console.log(crcResult64);
  const byteArray = base64ToByteArray(crcResult64);
  console.log(byteArray);
  const hexByteArray = byteArrayToHexString(byteArray);
  console.log(hexByteArray);
  //console.log(calculateCRC16(hexByteArray).toString(16).toUpperCase());

  //Bse 64
  const crc16 = calculateCRC16(byteArray)
    .toString(16)
    .toUpperCase()
    .padStart(4, "0");
  console.log("From Base64", crc16);
};
reader.onerror = function (error) {
  console.log("Error: ", error);
};*/
</script>
